/**
 * Site Links Configuration
 * Single source of truth for all navigation links
 */

export const LINKS = {
  // Internal pages
  home: "/",
  features: "/features",
  pricing: "/#pricing",
  brands: "/brands",
  shoppers: "/shoppers",
  developers: "/developers",
  support: "/contact",
  merchantPortal: "/dashboard",
  onboarding: "/onboarding",
  
  // Dashboard routes
  dashboard: "/dashboard",
  promiseHealth: "/dashboard/promise-health",
  exceptionRadar: "/dashboard/exception-radar",
  approvals: "/dashboard/approvals",
  slackSettings: "/dashboard/settings/integrations/slack",
  proofSetup: "/dashboard/proof/setup",
  
  // Auth
  login: "/merchant/login",
  signin: "/merchant/login",
  
  // Docs
  docs: "/docs",
  docsSignals: "/docs/signals",
  docsSlack: "/docs/slack-integration",
  docsQuickstart: "/docs/quickstart",
  
  // External URLs (replace with actual URLs)
  shopifyInstallUrl: "https://apps.shopify.com/commerce-index", // Replace with actual Shopify app URL
  chromeExtensionUrl: "https://chrome.google.com/webstore/detail/ci-shopper", // Replace with actual Chrome extension URL
  
  // Calendly for sales-assisted flows
  calendly: "https://calendly.com/mithunkadur",
  
  // Legacy routes (for backwards compatibility)
  extension: "/shoppers",
  proof: "/brands",
  signals: "/developers"
};

/**
 * CTA Destination Rules
 * Maps button actions to their destinations
 */
export const CTA_DESTINATIONS = {
  // Merchant CTAs
  installShopify: LINKS.shopifyInstallUrl,
  seePricing: LINKS.pricing,
  startStarterTrial: "/checkout?plan=starter",
  startProTrial: "/checkout?plan=pro",
  talkToSales: LINKS.calendly,
  
  // Add-on CTAs
  enableSignalsApi: "/checkout?addon=signals_api",
  enableCIProofPro: "/checkout?addon=ci_proof_pro",
  requestMarketSignals: LINKS.calendly,
  
  // Consumer CTAs
  installCIShopper: LINKS.chromeExtensionUrl,
  
  // Builder CTAs
  exploreDocs: LINKS.docsSignals
};

/**
 * Navigation items for header
 */
export const NAV_ITEMS = {
  primary: [
    { label: "Features", href: LINKS.features },
    { label: "Pricing", href: LINKS.pricing },
    { label: "CI Shopper", href: LINKS.shoppers },
    { label: "For Brands", href: LINKS.brands },
    { label: "Support", href: LINKS.support }
  ],
  
  consumer: [
    { label: "How it works", href: "#how" },
    { label: "Privacy", href: "#privacy" },
    { label: "For Merchants", href: LINKS.brands }
  ]
};

export default LINKS;
